import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import Styles from "../../../components/Styles";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import Copyrights from "../../../components/Copyrights";
import BookingPage from "./Booking";
import HotelBanner from "../../../components/hotel/Banner";
import BookingTopBanner from "./bookingBanner";

const HotelBooking = () => {
  const translationContext = useTranslation();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const {
    selectedRooms,
    totalPrice,
    hotelName,
    hotelLocation,
    checkIn,
    checkOut,
    nights,
    thumbnail,
    hotelStars,
  } = location.state || {};

  return (
    <div style={{ backgroundColor: "#EEEEEE", minHeight: "100vh" }}>
      <Styles />
      <Header translation={translationContext.t} translationContext={translationContext} />
      <BookingTopBanner />

      <div style={{ 
        maxWidth: isMobile ? "calc(100% - 32px)" : "1400px", 
        padding: 0, 
        margin: "0 auto",
        width: "100%"
      }}>
        <BookingPage
          selectedRooms={selectedRooms}
          totalPrice={totalPrice}
          hotelName={hotelName}
          hotelLocation={hotelLocation}
          checkIn={checkIn}
          checkOut={checkOut}
          nights={nights}
          thumbnail={thumbnail}
          hotelStars={hotelStars}
        />
      </div>

      <Footer />
      <Copyrights />
    </div>
  );
};

export default HotelBooking;
